<template>
	<div class="ganttboard" style="transition:1s">
		<Loading v-if="loading" opacity="0.5"/>
		<GBDialog
			:dialog="dialog" 
			@agree="onClickAgree"
			@disagree="onClickDisagree"
		/>
		<GBHeaderScheduleFiltering :value="$store.getters.isFiltering"/>
		<GBHeader
			:isEditable="$store.getters.isEditable"
			:use_photo="usePhoto"
			v-on:show-print-schedule="onClickShowPrintSchedule"
			v-on:show-edit-member-self="onShowEditMemberSelf"
			v-on:scroll-today="onScrollToday"
			v-on:specify-move-date="onScrollSpecifyDate"
			v-on:change-calendar-tick="onChangeCalendarTick"
			v-on:fetch-data="onFetchData"
			v-on:header-extension="onSetHeaderExtension"
			v-on:show-edit-project-pinned="onClickShowEditProjectPinned"
		/>
		<div class="gb-board-outer" :style="styleBoardOuter">
			<div class="d-flex">
				<GBHeaderScheduleList
					v-bind:narrow="isNarrowList"
					v-on:schedule-list-scroll-to="onScheduleListScrollTo"
					v-on:show-member-list="onClickShowMemberList"
					v-on:show-project-info="onClickShowProjectInfo"
					v-on:show-schedule-filtering="onClickShowScheduleFiltering"
					v-on:update-dataset="updateDataSet"
				/>
				<GBHeaderCalendar 
					v-on:hscroll-start="onHScrollStart"
					v-on:show-free-persons="onClickShowFreePersons"
				/>
			</div>
			<div class="gb-content-outer" v-bind:style="styleContentOuter"
				v-statemachine="statemachine_hscroll"
			>
				<div class="gb-content-inner" v-bind:style="styleInner">
					<div class="d-flex">
						<GBScheduleList
							v-bind:scroll_to="schedule_list_scroll_to"
							v-bind:narrow="isNarrowList"
							v-bind:items="$store.getters.display_list"
							v-bind:isEditable="$store.getters.isEditable"
							v-bind:use_photo="usePhoto"
							v-bind:ghost_schedule="ghost_schedule"
							v-on:show-project-info="onClickShowProjectInfo"
							v-on:show-member-info="onClickShowMemberInfo"
							v-on:show-add-member="onClickShowAddMember"
							v-on:update-dataset="updateDataSet"
							v-on:delete-member-from-project="onDeleteMemberFromProject"
						/>
						<div v-bind:style="styleLayer" style="position: relative;"
							v-bind:class="classInner"
						>
							<GBLayerBackground />
							<GBLayerChart 
								v-bind:items="this.$store.getters.display_list"
								v-bind:isEditable="this.$store.getters.isEditable"
								v-bind:ghost_schedule="ghost_schedule"
								v-on:hscroll-start="onHScrollStart"
								v-on:hscroll-stop="onHScrollStop"
								v-on:bar-move-start="barMoveStart"
								v-on:bar-stretch-start="barStretchStart"
								v-on:bar-move-break="barMoveBreak"
								v-on:chart-row-mouse-move="onMouseMoveChartRow"
								v-on:progress-rate-setting="onProgressRateSetting"
								v-on:request-ghost-schedule="onRequestGhostSchedule" />
						</div>
					</div>
				</div>
			</div>
			<div id="gb-hscroll" class="gb-hscroll-outer" v-bind:style="styleHScrollOuter" v-on:scroll="onHScroll">
				<div class="gb-hscroll-inner" v-bind:style="styleHScroll">
				</div>
			</div>
		</div><!-- ganttboard-board-outer -->
		<GBBottomPaneProgressRateSetting
			fetch="fetch"
			v-bind:value="bottom_sheet.progress_rate"
			v-bind:isEditable="this.$store.getters.isEditable"
			v-bind:selected_color="bottom_sheet.color_selected"
			v-on:show-color-select="onClickShowColorSelect"
			v-on:close="onCloseBottomSheet"
		/>
		<GBRightPaneFreePerson
			v-bind:value="right_pane.free_persons"
			v-on:close="onCloseRightPane"
			v-on:show-member-filtering="onClickShowMemberFiltering"
		/>
		<GBRightPaneMemberList
			v-bind:value="right_pane.member_list"
			v-bind:isEditable="this.$store.getters.isEditable"
			v-on:close="onCloseRightPane"
			v-on:show-member-info="onClickShowMemberInfo"
			v-on:update-dataset="updateDataSet"
			v-on:show-member-filtering="onClickShowMemberFiltering"
		/>
		<GBRightPaneMemberInfo
			v-bind:value="right_pane.member_info"
			v-bind:selected_class="right_pane.class_selected"
			v-bind:selected_color="right_pane.color_selected"
			v-on:close="onCloseRightPane"
			v-on:show-class-select="onClickShowClassSelect"
			v-on:show-color-select="onClickShowColorSelect"
			v-on:update-dataset="updateDataSet"
		/>
		<GBRightPaneAddMember
			v-bind:value="right_pane.add_member"
			v-bind:members="this.$store.getters.workerMember"
			v-on:close="onCloseRightPane"
			v-on:update-dataset="updateDataSet"
			v-on:show-member-filtering="onClickShowMemberFiltering"
		/>
		<GBRightPaneProjectInfo
			v-bind:value="right_pane.project_info"
			v-bind:selected_class="right_pane.class_selected"
			v-bind:selected_color="right_pane.color_selected"
			v-on:close="onCloseRightPane"
			v-on:show-class-select="onClickShowClassSelect"
			v-on:show-color-select="onClickShowColorSelect"
			v-on:update-dataset="updateDataSet"
		/>
		<GBRightPanePrintSchedule
			v-bind:value="right_pane.print_schedule"
			v-on:close="onCloseRightPane"
		/>
		<GBRightPaneClassSelect
			v-bind:value="right_pane.class_select"
			v-on:show-project-info="onClickShowProjectInfo"
			v-on:class-selected="onClickClassSelected"
			v-on:close="onCloseRightPane"
			v-on:update-dataset="updateDataSet"
		/>
		<GBRightPaneScheduleFiltering
			v-bind:value="right_pane.schedule_filtering"
			v-bind:selected_class="right_pane.class_selected"
			v-bind:color_selected_filtering_project="right_pane.color_selected_filtering_project"
			v-bind:color_selected_filtering_member="right_pane.color_selected_filtering_member"
			v-on:close="onCloseRightPane"
			v-on:show-project-select="onClickShowProjectSelect"
			v-on:show-member-select="onClickShowMemberSelect"
			v-on:show-class-select="onClickShowClassSelect"
			v-on:show-color-select="onClickShowColorSelect"
			v-on:fetch-data="onFetchData"
		/>
		<GBRightPaneProjectSelect
			v-bind:value="right_pane.project_select"
			v-on:close="onCloseRightPane"
		/>
		<GBRightPaneMemberSelect
			v-bind:value="right_pane.member_select"
			v-on:close="onCloseRightPane"
		/>
		<GBRightPaneMemberFiltering
			v-bind:value="right_pane.member_filtering.filter"
			v-bind:display_date="right_pane.member_filtering.display_date"
			v-bind:selected_class="right_pane.class_selected"
			v-on:close="onCloseRightPane"
			v-on:do-filtering="onCloseMemberFiltering"
			v-on:clear-filtering="onClickClearMemberFiltering"
			v-on:show-class-select="onClickShowClassSelect"
		/>
		<GBRightPaneColorSelect
			v-bind:value="right_pane.color_select"
			v-on:color-selected="onClickColorSelected"
			v-on:close="onCloseRightPane"
			v-on:update-dataset="updateDataSet"
		/>
		<GBRightPaneProjectPenned 
			v-bind:value="right_pane.project_pinned"
			fetch="fetch"
			v-on:close="onCloseRightPane"
			v-on:update-dataset="updateDataSet"
		/>
	</div>
</template>
<script>
import _ from 'lodash';
import clonedeep from 'lodash/cloneDeep';
import Loading from './Loading';
import GBHeader from './GBHeader';
import GBHeaderScheduleList from './GBHeaderScheduleList';
import GBHeaderCalendar from './GBHeaderCalendar';
import GBScheduleList from './GBScheduleList';
import GBLayerChart from './GBLayerChart';
import GBLayerBackground from './GBLayerBackground';
import GBBottomPaneProgressRateSetting from './GBBottomPaneProgressRateSetting';
import GBRightPaneFreePerson from './GBRightPaneFreePerson';
import GBRightPaneMemberList from './GBRightPaneMemberList';
import GBRightPaneMemberInfo from './GBRightPaneMemberInfo';
import GBRightPaneAddMember from './GBRightPaneAddMember';
import GBRightPaneProjectInfo from './GBRightPaneProjectInfo';
import GBRightPaneClassSelect from './GBRightPaneClassSelect';
import GBRightPaneScheduleFiltering from './GBRightPaneScheduleFiltering';
import GBRightPaneMemberFiltering from './GBRightPaneMemberFiltering';
import GBRightPaneProjectSelect from './GBRightPaneProjectSelect';
import GBRightPaneMemberSelect from './GBRightPaneMemberSelect';
import GBRightPanePrintSchedule from './GBRightPanePrintSchedule.vue';
import GBRightPaneColorSelect from './GBRightPaneColorSelect.vue';
import GBRightPaneProjectPenned from './GBRightPaneProjectPenned.vue';
import GBHeaderScheduleFiltering from './GBHeaderScheduleFiltering';
import GBDialog from './GBDialog';
import LongPressEventData from '../data/LongPressEventData';
import MouseState from '../classes/MouseState';
import MouseStateMachine from '../classes/MouseStateMachine';
import DataSetManager from '../classes/DataSetManager';
import { PERMISSION, UNIT_WIDTH, FORM_MODE, CALENDAR_TICK } from '../data/Const';
import Notification from '../classes/Notification';
import ScheduleTick from '../data/ScheduleTick';
const strftime = require('strftime');
import Util from '../classes/Util';
import APIClient from '../classes/APIClient';
import Color from '../data/Color';

const onHScrollMove = _.throttle(function(thiz, e) {
	if (!thiz.hscroll.enabled)
		return;

	let amount = e.pageX - thiz.hscroll.x;
	if (amount == 0)
		return;

	thiz.hscroll.x = e.pageX;
	thiz.$store.dispatch('hscrollMove', amount);
	thiz.onExpandDisplayArea(thiz.$store.getters.hscroll - amount);
}, 10);

const disableHScroll = (thiz) => {
	thiz.hscroll.enabled = false;
};

const _createExpandPeriod = function(thiz, is_expand_forward) {
	let begin_base = thiz.$store.getters.baseDate;
	let end_base = thiz.$store.getters.endDate;
	let begin = null;
	let end = null;
	let expandDate = thiz.$store.getters.expandDate;
	if (is_expand_forward) {
		begin = new Date(begin_base.getTime());
		begin.setDate(begin.getDate() - expandDate);
		end = new Date(begin_base.getTime());
		end.setDate(end.getDate() - 1);
	}else{
		begin = new Date(end_base.getTime());
		begin.setDate(begin.getDate() + 1);
		end = new Date(end_base.getTime());
		end.setDate(end.getDate() + expandDate);
	}
	return {begin: begin, end: end};
};

const _createExpandAllPeriod = function(thiz, is_expand_forward) {
	let begin_base = thiz.$store.getters.baseDate;
	let end_base = thiz.$store.getters.endDate;
	let begin = null;
	let end = null;
	let display_period = thiz.$store.getters.displayPeriod;
	if (is_expand_forward) {
		begin = new Date(begin_base.getTime());
		begin.setDate(begin.getDate() - display_period.expand);
		end = new Date(begin.getTime());
		end.setDate(end.getDate() + (display_period.default + display_period.offset));
	}else{
		end = new Date(end_base.getTime());
		end.setDate(end.getDate() + display_period.expand);
		begin = new Date(end.getTime());
		begin.setDate(begin.getDate() - (display_period.default + display_period.offset));
	}
	return {begin: begin, end: end};
};

const findGBList = (elem) => {
	let found = null;

	if (elem.classList.contains('gb-list')) {
		found = elem;
	} else {
		found = elem.closest('.gb-list');
	}

	return found;
}

export default {
	data () {
		const state_hscroll_default = new MouseState({
			down: (e) => {
				let obj = e.targetTouches ? e.targetTouches[0] : e;
				let found = findGBList(document.elementFromPoint(obj.pageX, obj.pageY));
				if (!found)
					this.onHScrollStart({x: obj.pageX});
			},
		});
		return {
			sm_mypointer: null,
			sm_mouse: null,
			event_target: null,
			hscroll: {
				enabled: false, 
				x: 0,
			},
			pointer_event: {
				up: { handler: null },
				down: { handler: null },
			},
			long_press_event: new LongPressEventData(),
			bottom_sheet: {
				progress_rate: null,
				color_selected: null,
			},
			right_pane: {
				free_persons: null,
				member_list: null,
				member_info: null,
				add_member: null,
				project_info :null,
				class_select: null,
				class_selected: null,
				schedule_filtering: null,
				project_select: null,
				member_select: null,
				print_schedule: null,
				member_filtering: {
					filter: null,
					display_date: null,
				},
				project_pinned: null,
				color_select: null,
				color_selected: null,
				color_selected_filtering_project: null,
				color_selected_filtering_member: null,
			},
			ExpandDisplayArea: true,
			dataset_manager: this.$store.getters.datasetManager,
			statemachine_hscroll: new MouseStateMachine(state_hscroll_default),
			schedule_list_scroll_to: null,
			dialog: {
				display: false,
				title: null,
				text: null,
				disagree: null,
				agree: null,
			},
			loading: false,
			use_photo: false,
			ghost_schedule: null,
			header_extension: true,
		}
	},
	components: {
		Loading,
		GBHeader,
		GBHeaderScheduleList,
		GBHeaderCalendar,
		GBScheduleList,
		GBLayerChart,
		GBLayerBackground,
		GBBottomPaneProgressRateSetting,
		GBRightPaneFreePerson,
		GBRightPaneMemberList,
		GBRightPaneMemberInfo,
		GBRightPaneAddMember,
		GBRightPaneProjectInfo,
		GBRightPaneClassSelect,
		GBRightPaneScheduleFiltering,
		GBRightPaneProjectSelect,
		GBRightPaneMemberSelect,
		GBRightPanePrintSchedule,
		GBRightPaneColorSelect,
		GBHeaderScheduleFiltering,
		GBRightPaneMemberFiltering,
		GBRightPaneProjectPenned,
		GBDialog,
	},
	methods: {
		onHScrollStart: function(e) {
			this.hscroll.x = e.x;
			this.hscroll.enabled = true;
		},
		onHScrollStop: function() {
			disableHScroll(this);
		},
		onMouseMove: function(e) {
			let obj = e.targetTouches && e.targetTouches.length > 0 ? e.targetTouches[0] : e;
			
			/* for long press */
			this.long_press_event.refresh_mouse_pointer_from_event(obj);

			onHScrollMove(this, obj);
			if(this.event_target){
				this.onBarMove(obj);
			}
		},
		onMouseUp: function(e) {
			disableHScroll(this);
			let obj = e.changedTouches ? e.changedTouches[0] : e;

			if(this.event_target){
				this.onBarMoveEnd(obj);

				this.ghost_schedule = null;
				this.event_target = null;
			}
		},
		onHScroll: function(e) {
			let scroll = e.target.scrollLeft;
			// let range = e.target.scrollWidth - e.target.offsetWidth;
			this.$store.dispatch('hscroll', scroll);
			this.onExpandDisplayArea(scroll);
		},
		onPageShow: function(e) {
			if (e.persisted)
				window.location.reload();
		},
		onWindowResize: function() {
			Util.onWindowResize(() => {
				this.$store.dispatch('setWindowSize', {
					width: window.innerWidth,
					height: window.innerHeight,
				});
			});
		},
		moveToday: function(){
			this.$store.dispatch('moveToday');
		},
		moveDefaultDay: function(){
			if (this.$store.getters.saveDisplayLeftDay) {
				this.$store.dispatch('moveDefaultDay');
				let hscroll = this.$el.querySelector('#gb-hscroll');
				hscroll.scrollLeft = this.positionHScroll;
			} else {
				this.$store.dispatch('moveToday');
			}
		},
		barMoveStart: function(e) {
			this.dataset_manager.setBeforeDataset();
			if(this.event_target === null)
				this.event_target = e;
		},
		barStretchStart: function(e) {
			this.dataset_manager.setBeforeDataset();
			if(this.event_target === null)
				this.event_target = e;
		},
		onMouseMoveChartRow: function(e) {
			if (this.event_target == null)
				return;
			if (!this.event_target.isScheduleMove)
				return;
			if (this.event_target.target.$parent.item === e.target.item)
				return;
			if (this.event_target.target.$parent.item.item_type != e.target.item.item_type)
				return;

			if (e.target.item.isMember) {
				this.sortMember(e);
			}else{
				this.sortProject(e);
			}
		},
		sortMember: function(e){
			var project = this.event_target.target.$parent.$parent.$parent.item;
			if (e.target.parent !== project) {
				return ;
			}
			this.$store.dispatch('listProjectMemberMoveTo', {
				project_code: project.code,
				src_code: this.event_target.target.$parent.item.code,
				dst_code: e.target.item.code,
			});
		},
		sortProject: function(e){
			var chartrow = this.event_target.target.$parent;

			if (e.target.$parent.$parent !== chartrow.$parent.$parent)
				return;

			this.$store.dispatch('listProjectMoveTo', {
				src_code: this.event_target.target.$parent.item.code,
				dst_code: e.target.item.code,
			});
			this.$forceUpdate();
		},
		onBarMove: function(obj) {
			if(this.event_target.isScheduleMove) {
				this.onBarMoveScheduleMove(obj);
			} else if(this.event_target.isScheduleStrechBegin) {
				this.onBarMoveScheduleStrechBegin(obj);
			} else if(this.event_target.isScheduleStrechEnd) {
				this.onBarMoveScheduleStrechEnd(obj);
			}
		},
		onBarMoveScheduleMove: function(obj) {
			let tick_width = UNIT_WIDTH.TICK / this.$store.getters.unitTicks;
			let target = this.event_target.target.$el;
			let schedule = this.event_target.target.schedule;
			let base_date = this.$store.getters.calendarBaseDate;
			let offset_begin_ticks = schedule.begin.offsetTicks(base_date);
			let left_from = offset_begin_ticks * tick_width;
			let move = Math.floor(obj.pageX) - Math.floor(this.event_target.x);
			let left_to = left_from + move;
			
			target.style.left = left_to + "px";
		},
		onBarMoveScheduleStrechBegin: function(obj) {
			let target = this.event_target.target.$el;
			let schedule = this.event_target.target.schedule;
			let unit_ticks = this.$store.getters.unitTicks;
			let tick_width = UNIT_WIDTH.TICK / unit_ticks;
			let base_date = this.$store.getters.calendarBaseDate;
			let offset_ticks = schedule.offsetTicks(base_date);
			let ticks = schedule.ticks;
			let left_from = offset_ticks.begin * tick_width;
			let width_from = ticks * tick_width;
			let move = Math.floor(obj.pageX - this.event_target.x);
			let left_to = left_from + move;
			let width_to = width_from - move;
			
			if(width_to < UNIT_WIDTH.TICK) {
				width_to = UNIT_WIDTH.TICK;
			}
			let left_max = (offset_ticks.end + 1 - unit_ticks) * tick_width;
			if(left_to > left_max) {
				left_to = left_max;
			}
			
			target.style.left = left_to + "px";
			target.style.width = width_to + "px";
		},
		onBarMoveScheduleStrechEnd: function(obj) {
			let target = this.event_target.target.$el;
			let schedule = this.event_target.target.schedule;
			let unit_ticks = this.$store.getters.unitTicks;
			let tick_width = UNIT_WIDTH.TICK / unit_ticks;
			let ticks = schedule.ticks;
			let width_from = ticks * tick_width;
			let move = Math.floor(obj.pageX) - Math.floor(this.event_target.x);
			let width_to = width_from + move;
			
			if(width_to < UNIT_WIDTH.TICK) {
				width_to = UNIT_WIDTH.TICK;
			}
			target.style.width = width_to + "px";
		},
		onBarMoveEnd: function(obj) {
			let target = this.event_target.target.$el;
			let schedule = this.event_target.target.schedule;
			let unit_ticks = this.$store.getters.unitTicks;
			let tick_width = UNIT_WIDTH.TICK / unit_ticks;
			let base_date = this.$store.getters.calendarBaseDate;
			let offset_ticks = schedule.offsetTicks(base_date);
			let move = Math.floor(obj.pageX - this.event_target.x);
			let offset = 0;
			if (this.event_target.isScheduleMove) {
				offset = ((move > 0) ? (offset_ticks.end + 1) : offset_ticks.begin) % unit_ticks;
			} else if (this.event_target.isScheduleStrechBegin) {
				offset =  offset_ticks.begin % unit_ticks;
			} else if (this.event_target.isScheduleStrechEnd) {
				offset =  (offset_ticks.end + 1) % unit_ticks;
			}
			if (move < 0) {
				offset = offset - unit_ticks;
			}
			move += offset * tick_width;
			let unit = Math.trunc(move / UNIT_WIDTH.TICK);
			let remain = move % UNIT_WIDTH.TICK;

			if (remain < -(UNIT_WIDTH.TICK / 2))
				unit -= 1;
			if ((UNIT_WIDTH.TICK / 2) < remain)
				unit += 1;

			let tick = (unit * unit_ticks) - offset;
			let is_updated = this.$store.getters.isUpdated;
			
			if (tick == 0) {
				let style = this.event_target.target.styleChartBar;
				target.style.left = style.left;
				target.style.width = style.width;
				if (!is_updated)
					return;
			} else {
				let begin = schedule.begin.clone();
				let end = schedule.end.clone();
				let ticks = schedule.ticks;

				if(this.event_target.isScheduleMove) {
					begin.addTick(tick);
					end.addTick(tick);
				} else if(this.event_target.isScheduleStrechBegin) {
					if((ticks - tick) <= 1) {
						begin = end.clone().addTick(1 - unit_ticks);
					} else {
						begin.addTick(tick);
					}
				} else if(this.event_target.isScheduleStrechEnd) {
					if((ticks + tick) <= 1) {
						end = begin.clone().addTick(unit_ticks - 1);
					} else {
						end.addTick(tick);
					}
				}
				this.$store.dispatch('updateSchedule', {
					schedule_code: schedule.code,
					project_code: schedule.project_code,
					member_code: schedule.member_code,
					begin_code: begin.code,
					end_code: end.code,
				});
			}
			
			this.updateDataSet();
		},
		updateDataSet: function() {
			const onFail = (err) => {
				const callback = {
					401: () => {
						this.logout();
					},
				};
				Util.updateFail(this.$store, err.response, callback);
				let opt = {};
				opt.force_update = true;
				this.fetchData(opt);
			};
			const onTokenFail = () => {
				this.logout();
			};
			
			this.dataset_manager.setAfterDataset();
			let opt = {};
			if ((this.$store.getters.accessToken.pms & PERMISSION.TYPE.ADMIN) == 0)
				opt.member_only = true;
			this.dataset_manager.sync(null, onFail, onTokenFail, opt);
		},
		fetchData: async function(opt) {
			this.loading = true;
			await this.dataset_manager.updateDataSet(opt)
				.catch((e) => {
					if(e.token){
						this.$store.dispatch('addNotification', Notification.error('もう一度ログインしてください'));
						this.logout();
					}else{
						let notification = null;
						
						switch(e.response.status) {
						case 400:
							notification = Notification.error('リクエストに失敗しました', 'notificationCreateData');
							break;
						case 401:
							notification = Notification.error('もう一度ログインしてください', 'notificationCreateData');
							this.logout();
							break;
						case 403:
							notification = Notification.error('権限がありません', 'notificationCreateData');
							this.logout();
							break;
						case 404:
							notification = Notification.error('契約者情報の取得に失敗しました', 'notificationCreateData');
							break;
						case 500:
							notification = Notification.error('情報の取得に失敗しました', 'notificationCreateData');
							break;
						case 504:
							notification = Notification.error('タイムアウトしました', 'notificationCreateData');
							break;
						default :
							notification = Notification.error('通信に失敗しました', 'notificationCreateData');
							break;
						}
						
						if(notification)
							this.$store.commit('addNotification', notification);
					}
				})
				.finally(() => {
					this.loading = false;
				});
		},
		barMoveBreak: function() {
			this.ghost_schedule = null;
			this.event_target = null;
		},
		onProgressRateSetting: function(e) {
			disableHScroll(this);
			this.bottom_sheet.progress_rate = clonedeep(e);
		},
		onRequestGhostSchedule: function(e) {
			this.ghost_schedule = e;
		},
		onCloseBottomSheet: function() {
			this.bottom_sheet.progress_rate = null;
			this.bottom_sheet.color_selected = null;
		},
		onClickShowFreePersons: function(e) {
			if (!e)
				return;
			if (this.$store.getters.calendarTick === CALENDAR_TICK.DAY) {
				this.setFreePersonsFilter(e.key);
			}
			this.right_pane.free_persons = e;
		},
		setFreePersonsFilter: function(date_code) {
			let member_filter = {
				begin: String(date_code).substr(0, 4) + '-' + String(date_code).substr(4, 2) + '-' + String(date_code).substr(6, 2),
				begin_term: ScheduleTick.TERM.AM,
				end: String(date_code).substr(0, 4) + '-' + String(date_code).substr(4, 2) + '-' + String(date_code).substr(6, 2),
				end_term: ScheduleTick.TERM.PM,
				classes: [],
			}
			this.$store.dispatch('setMemberFilter', member_filter);
		},
		onScheduleListScrollTo: function(e) {
			this.schedule_list_scroll_to = e;
		},
		onClickShowMemberList: function() {
			this.right_pane.member_list = true;
		},
		onClickShowMemberInfo: function(e) {
			this.right_pane.member_info = clonedeep(e);
		},
		onClickShowAddMember: function(e) {
			if(e === undefined || e === null) return;
			this.right_pane.add_member = e;
			this.setFilterAddMember(e);
		},
		setFilterAddMember: function(project) {
			if (!project)
				return;

			let begin = null;
			let begin_term = null;
			let end = null;
			let end_term = null;
			if (project.schedules.length > 0) {
				let minBegin = String(Math.min(...project.schedules.map(s => Number(s.begin.code))));
				let maxEnd = String(Math.max(...project.schedules.map(s => Number(s.end.code))));
				begin = String(minBegin).substr(0, 4) + '-' + String(minBegin).substr(4, 2) + '-' + String(minBegin).substr(6, 2);
				begin_term = minBegin.substr(8, 1);
				end = String(maxEnd).substr(0, 4) + '-' + String(maxEnd).substr(4, 2) + '-' + String(maxEnd).substr(6, 2);
				end_term = maxEnd.substr(8, 1);
			}

			let member_filter = {
				begin: begin,
				begin_term: begin_term,
				end: end,
				end_term: end_term,
				classes: project.classes,
			}
			this.$store.dispatch('setMemberFilter', member_filter);
		},
		onClickShowPrintSchedule: function(e) {
			this.right_pane.print_schedule = e;
		},
		onClickShowProjectInfo: function(e) {
			this.right_pane.project_info = clonedeep(e);
		},
		onClickShowClassSelect: function(e) {
			let is_filter_item = false;
			if (this.right_pane.schedule_filtering)
				is_filter_item = true;
			this.right_pane.class_select = {
				selected: e,
				master_classes: clonedeep(this.$store.getters.masterClass).map(c => {
					c.is_new = 0;
					return c;
				}),
				is_filter_item: is_filter_item,
			};
		},
		onClickClassSelected: function(e) {
			this.right_pane.class_selected = e;
		},
		onClickShowProjectSelect: function(e) {
			this.right_pane.project_select = e;
		},
		onClickShowMemberSelect: function(e) {
			this.right_pane.member_select = e;
		},
		onClickShowScheduleFiltering: function(e) {
			e.additional_info_data = this.$store.getters.additionalInfo.map(add => {
				const data = e.additional_info_data.filter(i => {
					return i.code == add.code;
				});
				return data.length > 0 ? data[0] : {
					code: add.code,
					name: '',
					min: '',
					max: '',
				};
			})
			this.right_pane.schedule_filtering = e;
		},
		onClickShowMemberFiltering: function(e) {
			let member_filter = this.$store.getters.memberFilter;
			if (member_filter && member_filter.classes && member_filter.classes.length > 0) {
				this.right_pane.class_selected = clonedeep(member_filter.classes);
			}
			this.right_pane.member_filtering.filter = clonedeep(this.$store.getters.memberFilter); 
			this.right_pane.member_filtering.display_date = e;
		},
		onClickShowColorSelect: function(e) {
			this.right_pane.color_select = {
				selected: e.color,
				type: e.type,
				select_type: e.select_type,
				master_colors: clonedeep(this.$store.getters.masterColor).map(c => {
					c.is_new = 0;
					return c;
				}),
			};
		},
		onClickColorSelected: function(e) {
			if (this.bottom_sheet.progress_rate) {
				this.bottom_sheet.color_selected = e;
				return ;
			}
			if (this.right_pane.schedule_filtering) {
				if (this.right_pane.color_select.type === Color.RELATION_TYPE.PROJECT)
					this.right_pane.color_selected_filtering_project = e;
				else
					this.right_pane.color_selected_filtering_member = e;
				return ;
			}
			this.right_pane.color_selected = e;
		},
		onCloseRightPane: function() {
			if(this.right_pane.class_select){
				this.right_pane.class_select = null
				return ;
			}
			if(this.right_pane.color_select){
				this.right_pane.color_select = null
				return ;
			}
			this.right_pane.class_selected = null;
			this.right_pane.color_selected = null;
			this.right_pane.color_selected_filtering_project = null;
			this.right_pane.color_selected_filtering_member = null;
			if(this.right_pane.member_info){
				this.right_pane.member_info = null
				return ;
			}
			if(this.right_pane.project_select){
				this.right_pane.project_select = null;
				return ;
			}
			if(this.right_pane.member_select){
				this.right_pane.member_select = null;
				return ;
			}
			if(this.right_pane.member_filtering.filter){
				this.right_pane.member_filtering.filter = null;
				this.right_pane.member_filtering.display_date = null;
				return ;
			}
			
			this.right_pane.free_persons = null;
			this.right_pane.member_list = null;
			this.right_pane.add_member = null;
			this.right_pane.project_info = null;
			this.right_pane.schedule_filtering = null;
			this.right_pane.print_schedule = null;
			this.right_pane.project_pinned = null;
			this.clearMemberFilter();
		},
		clearMemberFilter: function() {
			let member_filter = {
				begin: null,
				begin_term: null,
				end: null,
				end_term: null,
				classes: [],
			}
			this.$store.dispatch('setMemberFilter', member_filter);
		},
		onCloseMemberFiltering: function(e) {
			this.$store.dispatch('setMemberFilter', e);
			this.right_pane.member_filtering.filter = null;
			this.right_pane.member_filtering.display_date = null;
		},
		onClickClearMemberFiltering: function() {
			this.right_pane.class_selected = null;
		},
		expandData: async function(is_expand_forward, expand_period, all_period) {
			let access_token = await DataSetManager.confirmAccessToken(this.$store);
			if(!access_token){
				this.$store.dispatch('addNotification', Notification.error('もう一度ログインしてください'));
				this.logout();
				return;
			}
		
			let allFetch = false;
			await this.dataset_manager.fetch(access_token, strftime('%Y%m%d', expand_period.begin), strftime('%Y%m%d', expand_period.end))
				.then((data) => {
					if(data.dataset_id == this.$store.getters.datasetID){
						this.$store.commit('addExtendedData', {
							response: data,
							is_expand_forward: is_expand_forward,
							all_period : all_period
						});
					} else {
						allFetch = true;
					}
				})
				.catch((e) => {
					throw e;
				});
			
			if (!allFetch)
				return;
			
			await this.dataset_manager.fetch(access_token, strftime('%Y%m%d', all_period.begin), strftime('%Y%m%d', all_period.end))
				.then((data) => {
					this.$store.commit('createData', data);
				})
				.catch((e) => {
					throw e;
				});
		},
		logout: function() {
			this.$store.dispatch('logout');
			this.$router.push({name: 'Login', params: { 'contractor_id': this.$route.params.contractor_id }});
		},
		onExpandDisplayArea: _.throttle(function(scrollLeft) {
			if (this.ExpandDisplayArea === false) {
				return;
			}
			let max = this.$store.getters.innerWidth - (this.$store.getters.width + 0.3 - this.$store.getters.listWidth);
			if (scrollLeft <= 0 || max <= scrollLeft) {
				this.ExpandDisplayArea = false;
				let is_expand_forward = scrollLeft <= 0;
				let expand_period = _createExpandPeriod(this, is_expand_forward);
				let all_period = _createExpandAllPeriod(this, is_expand_forward);
				let left_day = this.$store.getters.displayLeftDay;

				this.loading = true;
				this.expandData(is_expand_forward, expand_period, all_period).then(() => {
					let target;
					if (is_expand_forward){
						target = new Date(expand_period.end.getTime());
						target.setDate(target.getDate() + 1);
					} else {
						target = left_day;
					}
					this.$nextTick(() => {
						let max = this.$store.getters.innerWidth - (this.$store.getters.width + 0.3 - this.$store.getters.listWidth);
						let scroll = this.$store.getters.positionAnyday(target);
						this.$store.dispatch('hscroll', Math.min(scroll, max - 1));
						this.ExpandDisplayArea = true;
					});
				})
				.catch((e) => {
					let notification = null;
					switch(e.response.status) {
					case 400:
						notification = Notification.error('リクエストに失敗しました', 'notificationCreateData');
						break;
					case 401:
						notification = Notification.error('もう一度ログインしてください', 'notificationCreateData');
						this.logout();
						break;
					case 403:
						notification = Notification.error('権限がありません', 'notificationCreateData');
						this.logout();
						break;
					case 404:
						notification = Notification.error('契約者情報の取得に失敗しました', 'notificationCreateData');
						break;
					case 500:
						notification = Notification.error('情報の取得に失敗しました', 'notificationCreateData');
						break;
					case 504:
						notification = Notification.error('タイムアウトしました', 'notificationCreateData');
						break;
					default :
						notification = Notification.error('通信に失敗しました', 'notificationCreateData');
						break;
					}
					if(notification)
						this.$store.commit('addNotification', notification);
					this.ExpandDisplayArea = true;
				})
				.finally(() => {
					this.loading = false;
				});
			}
		}, 800),
		onShowEditMemberSelf: function() {
			let access_token = this.$store.getters.accessToken;
			if (!access_token)
				return;

			let member = this.$store.getters.mstMemberData(access_token.sub);
			if (!member)
				return;

			this.right_pane.member_info = {
				'member': clonedeep(member),
				'mode': FORM_MODE.EDIT,
			};
		},
		onScrollToday: async function() {
			let base_date = this.$store.getters.baseDate;
			let end_date = this.$store.getters.endDate;
			let display_days = this.$store.getters.displayDays();
			let today = new Date();
			today = new Date(strftime('%Y/%m/%d', today));
			let right_day = new Date(today.getTime());
			right_day.setDate(right_day.getDate() + display_days);
			if (today <= base_date || end_date <= right_day) {
				await this.fetchData({
					default_period: true,
					force_update: true,
				});
			}
			this.$nextTick(() => {
				this.$store.dispatch('scrollToday');
			});
		},
		onScrollSpecifyDate: async function(e) {
			let base_date = this.$store.getters.baseDate;
			let end_date = this.$store.getters.endDate;
			let display_days = this.$store.getters.displayDays();
			let specify_date = e;
			specify_date = new Date(strftime('%Y/%m/%d', specify_date));
			let right_day = new Date(specify_date.getTime());
			right_day.setDate(right_day.getDate() + display_days);
			
			if (specify_date <= base_date || end_date <= right_day) {
				let begin = clonedeep(specify_date);
				begin.setDate(begin.getDate() - this.$store.getters.displayPeriod.offset);
				let end = clonedeep(specify_date);
				end.setDate(end.getDate() + this.$store.getters.displayPeriod.default);
				await this.fetchData({
					default_period: false,
					period: {
						begin: strftime('%Y%m%d', begin),
						end: strftime('%Y%m%d', end),
					},
					force_update: true,
				});
			}
			
			this.$nextTick(() => {
				let scroll = this.$store.getters.positionAnyday(e);
				this.$store.dispatch('scrollSpecifyDate', scroll);
			});
		},
		onChangeCalendarTick: async function(e) {
			let left_date = this.$store.getters.displayLeftDay;
			let right_date = left_date;
			right_date.setDate(right_date.getDate() + this.$store.getters.displayDays(e.value) + this.$store.getters.displayPeriodMargin(e.value));
			let begin_date = this.$store.getters.baseDate;

			let is_show_free = e.value != CALENDAR_TICK.WEEK;
			this.$store.dispatch('setShowFreePerson', is_show_free);

			await this.fetchData({
				force_update: true,
				period: {
					begin: strftime('%Y%m%d', begin_date),
					end: strftime('%Y%m%d', right_date),
				},
			});
			
			this.$store.dispatch('switchCalendarTick', e.value);
		},
		onFetchData: function(e) {
			this.fetchData(e)
		},
		confirmationDialog: function(text, agree) {
			this.dialog.title = '確認';
			this.dialog.text = text;
			this.dialog.disagree = () => {
				this.dialog.display = false;
			};
			this.dialog.agree = agree;
			this.dialog.display = true;
		},
		onClickDisagree: function() {
			if (this.dialog.disagree)
				this.dialog.disagree();
			return;
		},
		onClickAgree: function() {
			if (this.dialog.agree)
				this.dialog.agree();
			return;
		},
		onDeleteMemberFromProject: function(e) {
			const agree = () => {
				if (e.callback)
					e.callback();
				this.dialog.display = false;
				this.dialog.agree = null;
				this.$store.commit('deleteMemberFromProject', {
					project_code: e.project.code,
					member_code: e.member.code,
				});
				this.updateDataSet();
			};
			this.confirmationDialog('プロジェクトからメンバーを削除しますが、よろしいでしょうか', agree);
		},
		getContractor: function() {
			let api = new APIClient(this.$store);
			api.getContractor()
				.then((res) => {
					this.use_photo = res.data.contractor.attr == 1;
				})
				.catch(() => {
					this.logout();
				});
		},
		onSetHeaderExtension: function(e) {
			this.header_extension = e;
		},
		onClickShowEditProjectPinned: function(e) {
			let access_token = this.$store.getters.accessToken;
			if (!access_token)
				return;

			this.right_pane.project_pinned = {
        code: e,
        items: clonedeep(this.$store.getters.projectPinned(e)),
			};
		},
	},
	computed: {
		styleBoardOuter: function() {
			let left = this.$store.getters.boardLeftPosition;
			let width = this.$store.getters.width - left;

			return {
				width: width + 'px',
				left: left + 'px',
			};
		},
		styleContentOuter: function() {
			let hscroll_height = 19;
			let ua = navigator.userAgent;
			if (Util.isiOS() || ua.indexOf('Android') > 0) {
				hscroll_height = 0;
			}
			let header = 120;
			if(this.$store.getters.isFiltering)
				header = 188;
			if (this.header_extension)
				header += 30;
			return {
				height: (this.$store.getters.height - header - hscroll_height) + 'px',
			};
		},
		styleInner: function() {
			let width = this.$store.getters.innerWidth;
			return {
				width: width  + 'px',
			};
		},

		styleLayer: function() {
			return {
				left: (- this.$store.getters.hscroll) + 'px',
			};
		},
		styleHScroll: function() {
			let width = this.$store.getters.innerWidth;
			return {
				width: width + 'px',
			};
		},
		positionHScroll: function() {
			return this.$store.getters.hscroll;
		},
		classInner: function(){
			if(this.$store.getters.isScrollingToToday){
				return "transition-move-to-today";
			}
			return "";
		},
		styleHScrollOuter: function() {
			let margin_left = this.$store.getters.listWidth - this.$store.getters.boardLeftPosition;
			return {
				'margin-left': margin_left + 'px',
			};
		},
		isNarrowList: function() {
			return this.$store.getters.isListWidthNarrow;
		},
		usePhoto: function() {
			return this.use_photo && this.$store.getters.isAdmin;
		},
	},
	watch: {
		positionHScroll: function() {
			let hscroll = this.$el.querySelector('#gb-hscroll');
			hscroll.scrollLeft = this.positionHScroll;
		},
	},
	created: function() {
		/* event pointer */
		this.pointer_event.down.handler = (e) => {
			let obj = e.targetTouches ? e.targetTouches[0] : e;
			let event = new CustomEvent('my-pointerdown', {
				bubbles: true,
				cancelable: true,
				detail: obj,
			});
			this.long_press_event.refresh_mouse_pointer_from_event(obj);

			e.target.dispatchEvent(event);
		};
		this.pointer_event.up.handler = (e) => {
			let obj = e.targetTouches ? e.targetTouches[0] : e;
			let event = new CustomEvent('my-pointerup', {
				bubbles: true,
				cancelable: true,
				detail: obj,
			});
			e.target.dispatchEvent(event);
		};
		
		const state_default = new MouseState({
			down: (e, next) => {
				this.pointer_event.down.handler(e);
				next(state_moving_mypointer);
			},
		});
		const state_moving_mypointer = new MouseState({
			up: (e, next) => {
				this.pointer_event.up.handler(e);
				next(state_default);
			},
		});
		this.sm_mypointer = new MouseStateMachine(state_default, true);
		this.sm_mypointer.bind(window);
		
		/* event longpress */
		const ON_POINTER_UP = (e) => {
			let event = new CustomEvent('long-press-stop', {
				bubbles: true,
				cancelable: true,
			});
			clearTimeout(this.long_press_event.timer);
			e.target.dispatchEvent(event);
			document.removeEventListener('my-pointerup', ON_POINTER_UP);
		};
		const ON_POINTER_DOWN = (e) => {
			let event = new CustomEvent('long-press-start', {
				bubbles: true,
				cancelable: true,
			});
			let obj = this.long_press_event.create_mouse_point(e.detail);
			document.addEventListener('my-pointerup', ON_POINTER_UP);
			this.long_press_event.timer = setTimeout(() => {
				if (this.long_press_event.validate_mouse_pointer(obj)) {
					e.target.dispatchEvent(event);
				}
			}, 500);
		};
		document.addEventListener('my-pointerdown', ON_POINTER_DOWN);
		this.long_press_event.handler = ON_POINTER_DOWN;
		
		const state_moving_mouse = new MouseState({
			move: (e) => {
				this.onMouseMove(e);
			},
			up: (e) => {
				this.onMouseUp(e);
			},
		});
		
		this.sm_mouse = new MouseStateMachine(state_moving_mouse);
		this.sm_mouse.bind(window);
		
		window.addEventListener('pageshow' , this.onPageShow, false);
		window.addEventListener('resize', this.onWindowResize, false);

		this.onWindowResize();
	},
	beforeDestroy: function() {
		document.removeEventListener('my-pointerdown', this.long_press_event.handler);
		window.removeEventListener('resize', this.onWindowResize);
		window.removeEventListener('pageshow' , this.onPageShow);
		this.sm_mypointer.unbind();
		this.sm_mouse.unbind();
	},
	mounted: function() {
		this.getContractor();
		this.moveDefaultDay();
	}
};
</script>
<style>
	.ganttboard {
		width: 100%;
		background-color: #ededed;
		-moz-user-select: none;
		-webkit-user-select: none;
		-ms-user-select: none;
		transition:1s,
	}

	.gb-board-outer {
		position: absolute;
		transition: left ease .3s;
	}

	.gb-content-outer {
		overflow-y: scroll;
		overflow-x: hidden;
		width: 100%;
		-webkit-overflow-scrolling: touch;
	}

	.gb-content-inner {
		position: relative;
	}

	.gb-hscroll-outer {
		overflow-x: scroll;
		overflow-y: hidden;
	}

	.gb-hscroll-inner {
		height: 1px;
	}
	.transition-move-to-today{
		transition: 1s;
	}
</style>
